import { availableIcons } from "@/helpers/feature/available-icons-list";
import axios from "axios";

const state = {
  availableIcons: availableIcons,
  currentFeature: {
    id: null,
    category: null,
    text: null,
    icon: null
  },
  features: [],
  featureCategories: [
    "Storage Solutions",
    "Amenities",
    "Safety and Security"
  ],
  loadingState: [],
  pagination: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["text"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
    totalItems: 0,
    rowsPerPageOptions: [25, 50, 75, 100]
  }
};

const actions = {
  getAllFeatures: ({ commit, dispatch, state }) => {
    commit("addToLoadingState", "retrieving all features");
    const sortingOrder = state.pagination.sortDesc[0] ? "desc" : "asc";
    return axios.get(`/facility-features`, {
      params: {
        page: state.pagination.page,
        per_page: state.pagination.itemsPerPage,
        sort: state.pagination.sortBy[0],
        order: sortingOrder
      }
    })
      .then((resp) => {
        commit("getAllFeaturesSuccess", resp.data.features);
        commit("removeFromLoadingState", "retrieving all features");
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", "Unable to retrieve features", { root: true });
        commit("removeFromLoadingState", "retrieving all features");
        return Promise.reject(err);
      });
  },
  getAllFeaturesForFacility: ({ commit, dispatch, state }, payload) => {
    commit("addToLoadingState", "retrieving all features for facility");
    const sortingOrder = state.pagination.sortDesc[0] ? "desc" : "asc";
    const perPage = payload && payload.perPage ? payload.perPage : state.pagination.itemsPerPage;

    return axios.get(`/facility-features`, {
      params: {
        page: state.pagination.page,
        per_page: perPage,
        sort: state.pagination.sortBy[0],
        order: sortingOrder
      }
    })
      .then((resp) => {
        commit("getAllFeaturesForFacilitySuccess", resp.data.features);
        commit("removeFromLoadingState", "retrieving all features for facility");
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", "Unable to retrieve features for facility", { root: true });
        commit("removeFromLoadingState", "retrieving all features for facility");
        return Promise.reject(err);
      });
  },
  getFeature: ({ commit, dispatch }, id) => {
    commit("addToLoadingState", "retrieving feature");
    return axios.get(`/facility-features/${id}`)
      .then((resp) => {
        commit("getFeatureSuccess", resp.data);
        commit("removeFromLoadingState", "retrieving feature");
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        commit("removeFromLoadingState", "retrieving feature");
        return Promise.reject(err);
      });
  },
  createFeature: ({ commit, dispatch }, payload) => {
    commit("addToLoadingState", "creating feature");
    return axios.post(`/facility-features`, payload)
      .then((resp) => {
        dispatch("getAllFeatures");
        dispatch("snackbar/successMessage", "Successfully created feature", { root: true });
        commit("removeFromLoadingState", "creating feature");
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        commit("removeFromLoadingState", "creating feature");
        return Promise.reject(err);
      });
  },
  updateFeature: ({ state, commit, dispatch }) => {
    commit("addToLoadingState", "updating feature");
    const payload = {
      category: state.currentFeature.category,
      text: state.currentFeature.text,
      icon: state.currentFeature.icon
    };

    return axios.patch(
      `/facility-features/${state.currentFeature.id}`,
      payload
    ).then((resp) => {
      dispatch("snackbar/successMessage", "Successfully updated feature", { root: true });
      commit("removeFromLoadingState", "updating feature");
      return resp;
    }).catch((err) => {
      dispatch("snackbar/errorMessage", err, { root: true });
      commit("removeFromLoadingState", "updating feature");
      return Promise.reject(err);
    });
  },
  deleteFeature: ({ commit, dispatch }, id) => {
    commit("addToLoadingState", "deleting feature");
    return axios.delete(`/facility-features/${id}`)
      .then((resp) => {
        dispatch("getAllFeatures");
        dispatch("snackbar/successMessage", "Successfully deleted feature", { root: true });
        commit("removeFromLoadingState", "deleting feature");
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        commit("removeFromLoadingState", "deleting feature");
        return Promise.reject(err);
      });
  }
};

const mutations = {
  addToLoadingState: (state, message) => {
    state.loadingState.push(message);
  },
  removeFromLoadingState: (state, message) => {
    state.loadingState = state.loadingState.filter(loadingMessage => loadingMessage !== message);
  },
  getAllFeaturesSuccess: (state, featuresResponse) => {
    state.features = featuresResponse.data;
    state.pagination.totalItems = featuresResponse.total;
  },
  getAllFeaturesForFacilitySuccess: (state, featuresResponse) => {
    state.features = featuresResponse.data;
  },
  getFeatureSuccess: (state, featureResponse) => {
    state.currentFeature = featureResponse.feature;
  },
  setFeaturePagination: (state, payload) => {
    state.pagination = payload;
  }
};

export default {
  state,
  actions,
  mutations
};
